import React from 'react'
import styled from 'styled-components';
import loaderImage from '../../assets/loader.gif'

function Spinner() {
  return (
    <Wrapper>
      <img src={loaderImage} alt="loading..." />
    </Wrapper>
  )
}

export default Spinner;

const Wrapper = styled.div`

  img{
    position:fixed;
    top:50vh;
    left:50vw;
    width:10rem;
    height:10rem;
    z-index: 100;
  }
`
